// extracted by mini-css-extract-plugin
export var layoutContainer = "_43-0";
export var layoutContainerNoRounding = "_43-6";
export var layoutContainerOpen = "_43-5";
export var layoutContainerResizing = "_43-1";
export var mainContent = "_43-2";
export var resizeDivider = "_43-3";
export var slidePanel = "_43-4";